var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "comoon_edit_frame mb-24" },
    [
      _vm.$route.query.type == "imageText"
        ? _c(
            "div",
            { staticClass: "tab" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.activeName === "1" ? "primary" : "secondary",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setSelect("1")
                    },
                  },
                },
                [_vm._v("单个职位")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.activeName === "2" ? "primary" : "secondary",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setSelect("2")
                    },
                  },
                },
                [_vm._v("多个职位")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeName === "2" && _vm.$route.query.type == "imageText"
        ? _c(
            "div",
            { staticClass: "tips" },
            [
              _c(
                "el-alert",
                {
                  attrs: { type: "warning", "show-icon": "", closable: false },
                },
                [_vm._v(" 多个职位下不展示职位信息 ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.type === "module"
        ? [
            _c(
              "div",
              {
                staticClass: "title",
                class: _vm.$route.query.type == "imageText" ? "mt-24" : "",
              },
              [_vm._v("排列")]
            ),
            _c("div", { staticClass: "sort fx" }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      return _vm.move("up")
                    },
                  },
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { content: "上移一层", placement: "top" },
                    },
                    [
                      _c("i", {
                        staticClass: "iconfont icon icon-shangyiyiceng",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      return _vm.move("down")
                    },
                  },
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { content: "下移一层", placement: "top" },
                    },
                    [_c("i", { staticClass: "iconfont icon icon-xiayiyiceng" })]
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      return _vm.move("top")
                    },
                  },
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { content: "置于顶部", placement: "top" },
                    },
                    [_c("i", { staticClass: "iconfont icon icon-zhixudingbu" })]
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      return _vm.move("bottom")
                    },
                  },
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { content: "置于底部", placement: "top" },
                    },
                    [_c("i", { staticClass: "iconfont icon icon-zhixudibu" })]
                  ),
                ],
                1
              ),
            ]),
            ![
              "jobResponsibility",
              "qualifications",
              "positionInfo",
              "jobResponsibilityTitle",
              "qualificationsTitle",
            ].includes(_vm.module.textType)
              ? _c(
                  "div",
                  { staticClass: "position fx mt-16" },
                  [
                    _c(
                      "el-input-number",
                      {
                        key: 1,
                        staticClass: "mr-20",
                        attrs: {
                          "controls-position": "right",
                          placeholder: "请输入",
                          size: "medium",
                          controls: false,
                        },
                        model: {
                          value: _vm.module.style.left,
                          callback: function ($$v) {
                            _vm.$set(_vm.module.style, "left", $$v)
                          },
                          expression: "module.style.left",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "prepend-box",
                          attrs: { slot: "prepend", value: "X", readonly: "" },
                          slot: "prepend",
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-input-number",
                      {
                        key: 2,
                        attrs: {
                          "controls-position": "right",
                          placeholder: "请输入",
                          size: "medium",
                          controls: false,
                        },
                        model: {
                          value: _vm.module.style.top,
                          callback: function ($$v) {
                            _vm.$set(_vm.module.style, "top", $$v)
                          },
                          expression: "module.style.top",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "prepend-box",
                          attrs: { slot: "prepend", value: "Y", readonly: "" },
                          slot: "prepend",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            ![
              "jobResponsibility",
              "qualifications",
              "positionInfo",
              "jobResponsibilityTitle",
              "qualificationsTitle",
            ].includes(_vm.module.textType)
              ? _c(
                  "div",
                  { staticClass: "roate roat3 fx mt-16" },
                  [
                    _c(
                      "el-input-number",
                      {
                        key: 3,
                        staticClass: "mr-12",
                        attrs: {
                          "controls-position": "right",
                          placeholder: "请输入",
                          size: "medium",
                          controls: false,
                        },
                        model: {
                          value: _vm.module.style.width,
                          callback: function ($$v) {
                            _vm.$set(_vm.module.style, "width", $$v)
                          },
                          expression: "module.style.width",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "prepend-box",
                          attrs: { slot: "prepend", value: "宽", readonly: "" },
                          slot: "prepend",
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-input-number",
                      {
                        key: 4,
                        staticClass: "mr-12",
                        attrs: {
                          "controls-position": "right",
                          placeholder: "请输入",
                          size: "medium",
                          controls: false,
                        },
                        model: {
                          value: _vm.module.style.height,
                          callback: function ($$v) {
                            _vm.$set(_vm.module.style, "height", $$v)
                          },
                          expression: "module.style.height",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "prepend-box",
                          attrs: { slot: "prepend", value: "高", readonly: "" },
                          slot: "prepend",
                        }),
                      ],
                      1
                    ),
                    _c("my_rotate", {
                      staticClass: "mr-12",
                      attrs: { value: _vm.module.style.rotate },
                      on: {
                        "update:value": function ($event) {
                          return _vm.$set(_vm.module.style, "rotate", $event)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : [
            _c("div", { staticClass: "title mt-24" }, [_vm._v("海报尺寸")]),
            _vm.$route.query.type == "detail"
              ? _c("div", { staticClass: "subtitle" }, [_vm._v("宽度")])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "roate fx mt-16" },
              [
                _c(
                  "el-input-number",
                  {
                    staticClass: "mr-12",
                    attrs: {
                      min: 1,
                      max: 670,
                      "controls-position": "right",
                      placeholder: "请输入",
                      size: "medium",
                      controls: false,
                      disabled: _vm.$route.query.type == "detail",
                    },
                    model: {
                      value: _vm.$store.state.body.data.width,
                      callback: function ($$v) {
                        _vm.$set(_vm.$store.state.body.data, "width", $$v)
                      },
                      expression: "$store.state.body.data.width",
                    },
                  },
                  [
                    _c("el-input", {
                      staticClass: "prepend-box",
                      attrs: { slot: "prepend", value: "宽", readonly: "" },
                      slot: "prepend",
                    }),
                  ],
                  1
                ),
                _vm.$route.query.type != "detail"
                  ? _c(
                      "el-input-number",
                      {
                        attrs: {
                          min: 1,
                          max: 1192,
                          "controls-position": "right",
                          placeholder: "请输入",
                          size: "medium",
                          controls: false,
                        },
                        model: {
                          value: _vm.$store.state.body.data.height,
                          callback: function ($$v) {
                            _vm.$set(_vm.$store.state.body.data, "height", $$v)
                          },
                          expression: "$store.state.body.data.height",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "prepend-box",
                          attrs: { slot: "prepend", value: "高", readonly: "" },
                          slot: "prepend",
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "subtitle" }, [_vm._v("高度")]),
            _vm.$route.query.type == "detail"
              ? _c(
                  "div",
                  { staticClass: "roate fx mt-16" },
                  [
                    _vm.$store.state.body.data.pages.headerConfig
                      ? _c(
                          "el-input-number",
                          {
                            staticClass: "mr-12",
                            attrs: {
                              min: 1,
                              max: 300,
                              "controls-position": "right",
                              placeholder: "请输入",
                              size: "medium",
                              controls: false,
                            },
                            model: {
                              value:
                                _vm.$store.state.body.data.pages.headerConfig
                                  .style.height,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$store.state.body.data.pages.headerConfig
                                    .style,
                                  "height",
                                  $$v
                                )
                              },
                              expression:
                                "$store.state.body.data.pages.headerConfig.style.height",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "prepend-box",
                              attrs: {
                                slot: "prepend",
                                value: "头部",
                                readonly: "",
                              },
                              slot: "prepend",
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$store.state.body.data.pages.footerConfig
                      ? _c(
                          "el-input-number",
                          {
                            attrs: {
                              min: 1,
                              max: 300,
                              "controls-position": "right",
                              placeholder: "请输入",
                              size: "medium",
                              controls: false,
                            },
                            model: {
                              value:
                                _vm.$store.state.body.data.pages.footerConfig
                                  .style.height,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$store.state.body.data.pages.footerConfig
                                    .style,
                                  "height",
                                  $$v
                                )
                              },
                              expression:
                                "$store.state.body.data.pages.footerConfig.style.height",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "prepend-box",
                              attrs: {
                                slot: "prepend",
                                value: "底部",
                                readonly: "",
                              },
                              slot: "prepend",
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }